import { Imagem, Text, Titulo, Container } from './styles'

import rest from '../../assets/images/banner.png'

const Banner = () => {
  return (
    <Imagem style={{ backgroundImage: `url(${rest})` }}>
      <div className="container">
        <Container>
          <div>
            <Text>Comida japonesa</Text>
          </div>
          <div>
            <Titulo>Hioki Sushi</Titulo>
          </div>
        </Container>
      </div>
    </Imagem>
  )
}

export default Banner
